import axios from "axios"
import { baseUrl } from "../const"

const axiosConnectorInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
});

export default axiosConnectorInstance